import React from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";

const SECTIONS = [
  {
    h: "01 — Information We Collect",
    p: "Elliott International Development LLC ('EID', 'we', 'us') collects information you voluntarily provide through our website and contact forms, including your name, email address, phone number, firm or family office name, investor classification, and the contents of any message or inquiry you submit. We may also collect limited technical information automatically (such as IP address, browser type, device identifier, referring page, and pages visited) for security, fraud-prevention, and analytics purposes.",
  },
  {
    h: "02 — How We Use Information",
    p: "We use the information you provide solely to respond to your inquiries, deliver requested materials (including pitch decks and project briefings), evaluate prospective capital partnerships, communicate updates relating to our developments, and operate, secure and improve our website. We retain inquiry records for as long as reasonably necessary to maintain investor relations and comply with applicable law.",
  },
  {
    h: "03 — We Do Not Sell Personal Information",
    p: "EID does not sell, rent, or trade your personal information to third parties for marketing purposes. We may share information only with trusted service providers who assist us in operating our website, providing services, or conducting our business — and only to the extent reasonably necessary for those purposes — under appropriate confidentiality and data-protection commitments.",
  },
  {
    h: "04 — Cookies & Analytics",
    p: "Our website uses cookies and similar technologies to maintain your session, remember preferences, and measure how the site is used. We may use industry-standard analytics tools (such as cookie-based analytics) to understand aggregated visitor behavior. You can disable cookies in your browser settings; certain features of the site may not function correctly if you do.",
  },
  {
    h: "05 — Third-Party Links",
    p: "Our website may contain links to third-party websites, including media outlets, partners, and social platforms. We are not responsible for the privacy practices or content of those third-party sites. We encourage you to review the privacy policies of any third-party site you visit.",
  },
  {
    h: "06 — Data Security",
    p: "We implement reasonable administrative, technical and physical safeguards designed to protect the information we collect. No system, however, can be guaranteed 100% secure. By using our website you acknowledge that information transmission over the internet is at your own risk.",
  },
  {
    h: "07 — Updates to This Policy",
    p: "We may update this Privacy Policy from time to time to reflect changes in our practices, services, or applicable law. The 'Last Updated' date below indicates when the policy was most recently revised. Material changes will be highlighted on this page.",
  },
  {
    h: "08 — Contact",
    p: "For privacy questions, requests to access or delete your data, or any other concern relating to this policy, please contact us at contact@elliottdev.com or by mail at: Elliott International Development LLC, 410 S Ware Blvd, Tampa, FL 33619.",
  },
];

export default function PrivacyPage() {
  return (
    <Layout>
      <SEO title="Privacy Policy" description="Privacy Policy for Elliott International Development LLC." path="/privacy" />
      <section className="pt-40 pb-16 px-6 lg:px-12">
        <div className="max-w-[1200px] mx-auto">
          <div className="overline mb-6">— Legal</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.98] font-light tracking-tight">Privacy <em className="text-primary italic">Policy</em></h1>
          <p className="mt-6 font-mono text-xs text-foreground/50">Last updated: May 22, 2026</p>
        </div>
      </section>

      <section className="px-6 lg:px-12 pb-32">
        <div className="max-w-[1000px] mx-auto divide-y divide-primary/10 border-t border-primary/10">
          {SECTIONS.map((s) => (
            <div key={s.h} data-testid={`privacy-section-${s.h.slice(0, 2)}`} className="py-10">
              <div className="overline mb-4 text-primary">{s.h}</div>
              <p className="text-base md:text-lg text-foreground/80 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
